import React from 'react';
import classname from 'classnames';
import { range } from '../utils/numbers';
export default function Spin(props) {
  var spinClass = props.spinClass,
      _props$count = props.count,
      count = _props$count === void 0 ? 0 : _props$count,
      render = props.render,
      size = props.size,
      wrapperClass = props.wrapperClass,
      wrapperStyle = props.wrapperStyle;
  var style = Object.assign({
    width: size,
    height: size
  }, props.style, wrapperStyle);
  var className = classname(spinClass('_'), wrapperClass);

  if (count < 1 || !render) {
    return (
      /*#__PURE__*/
      React.createElement("div", {
        style: style,
        className: className
      })
    );
  }

  return (
    /*#__PURE__*/
    React.createElement("div", {
      style: style,
      className: className
    }, range(count + 1, 1).map(function (i) {
      return render(spinClass, i, props);
    }))
  );
}